/** Location state key for Lu.ma-style listing drawers over host/school public pages. */

export function listingDrawerState(location) {
  if (!location) return undefined;
  return {
    background: {
      pathname: location.pathname,
      search: location.search || "",
      hash: location.hash || "",
    },
  };
}

export function listingDrawerBackground(location) {
  return location?.state?.background || null;
}
